import { Duration, Schema } from 'effect';
import {
  HttpApiEndpoint,
  HttpApiGroup,
  HttpApiSchema,
  OpenApi,
} from 'effect/unstable/httpapi';
import { UserAuthMiddleware } from './middleware';
import {
  BadRequestError,
  FileTooLargeError,
  RateLimitedError,
  UnauthorizedError,
} from './errors';
import { OcrExtractResponse } from './schemas/ocr-dtos';
import { RequestTimeout } from './request-timeout';

// Synchronous image → text + word-boxes OCR. This is the one new backend primitive
// the Kindle overlay needs (the glyph scramble means page pixels are the only text
// source), and it also powers screenshot / scan-to-listen. It persists nothing —
// storing decoded page images/text is out of scope (see kindle-integration §4, D4).
//
// Client usage: the `@listening/frontend` kindle-extract bridge (mobile WebView +
// browser extension) and the mobile scan-to-listen flow.
const extractEndpoint = HttpApiEndpoint.post('Extract', '/ocr', {
  // Raw PNG bytes as the request body — mirrors Speechify's POST /ocr/extract shape.
  payload: Schema.Uint8Array.pipe(
    HttpApiSchema.asUint8Array({ contentType: 'image/png' }),
  ),
  success: OcrExtractResponse,
  error: [
    BadRequestError,
    FileTooLargeError,
    UnauthorizedError,
    RateLimitedError,
  ],
})
  .middleware(UserAuthMiddleware)
  .annotate(OpenApi.Summary, 'OCR a page image')
  .annotate(RequestTimeout, Duration.seconds(90))
  .annotate(
    OpenApi.Description,
    'Synchronously OCR a single page image (PNG) into text plus pixel-space per-word boxes. Persists nothing.',
  );

export const ocrGroup = HttpApiGroup.make('Ocr')
  .add(extractEndpoint)
  .prefix('/v2');
